import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';
import StockStatusProps, {
  StockStatusLevel,
} from '../../Types/StockStatus';

const getStockLevelColorClass = (level: StockStatusLevel) => {
  switch (level) {
    case 'Normal':
    case 'OnDemand':
      return 'bg-success-500';
    case 'Warning':
      return 'bg-warning-500';
    case 'SoldOut':
    default:
      return 'bg-error-500';
  }
};

const StockStatus: React.FC<
  StockStatusProps & React.HTMLAttributes<HTMLDivElement>
> = ({
  inStock,
  description,
  additionalDescription,
  level,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={clsx(
        className,
        'mb-4 flex items-center py-1 leading-tight'
      )}
    >
      <div
        className={clsx(
          getStockLevelColorClass(level),
          'mr-1.5 h-3 w-3 flex-none rounded-full'
        )}
      ></div>
      <span className="text-md font-bold leading-tight">
        {description}
        {additionalDescription && (
          <span className="font-light"> {additionalDescription}</span>
        )}
      </span>
    </div>
  );
};
export default StockStatus;
